import { Button, Col, Form, Modal, Row, message, Spin, Pagination } from 'antd'
import React, { useState, useEffect } from 'react'
import ModalQuestion from '../components/ModalQuestion';
import logoDel from '../assets/images/delete.png'
import { callDelete, getDataCallResult, postCall } from '../components/CommonApiCall';
import Search from 'antd/es/input/Search';

function Faq() {
  const [openAddModal, setOpenAddModal] = useState(false)
  const [openEditModal, setOpenEditModal] = useState(false)
  const [openDelModal, setOpenDelModal] = useState(false)
  const [searchText, setSearchText] = useState('');

  const [loading, setLoading] = useState(false)
  const [faq, setFaq] = useState([])
  const [editData, setEditData] = useState()
  const [delId, setDelId] = useState('')
  const [form] = Form.useForm();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 6,
    position: ['bottomRight'],
    // size: 'small'
  });


  /* call to api to get the Users Data */
  useEffect(() => {
    getData();
  }, [pagination.current, searchText])

  //** Called to fetch the users data record **//
  const getData = async () => {
    setLoading(true)
    const successCb = (response) => {
      setLoading(false)
      console.log("response123", response)
      setPagination((prevPagination) => ({
        ...prevPagination,
        total: response?.data?.other?.total_entries,
      }));
      let data = response?.data?.data?.map((item) => {
        return ({
          _id: item?._id,
          ques: item?.ques,
          ans: item?.ans,
        })
      })
      setFaq(data)
    }
    const failureCb = (response) => {
      setLoading(false)
      console.log("failure res", response)
      setFaq("")
      setPagination({
        current: 1,
        total: 0,
        pageSize: 6,
      });
    }
    getDataCallResult(pagination?.current, pagination?.pageSize, searchText, "/admin/get_faq_list", successCb, failureCb);
  }

  //*** to handle the Search Value ***//
  const handleSearch = (value) => {
    setSearchText(value);
    setPagination((prevPagination) => ({
      ...prevPagination,
      current: 1,
    }));
  };

  const handleEditButton = (record) => {
    console.log("edit values", record)
    let data = {
      _id: record?._id,
      title: record?.ques,
      message: record?.ans
    }
    setEditData(data)
    console.log("edit dated 2 check", data)
    setOpenEditModal(true);
  }

  const handleAddQuestion = (values) => {
    console.log("add question", values)
    setLoading(true)
    let data = {
      ques: values?.Name,
      ans: values?.Message
    }
    console.log("data123", data)
    // return false;
    let url = '/admin/add_faq'
    const successCb = (res) => {
      setLoading(false)
      console.log(res)
      getData()
      message.success("Data Updated Successfully")
      form.resetFields()
      setOpenAddModal(false)
    }
    const failureCb = (res) => {
      setLoading(false)
    }
    postCall(data, url, successCb, failureCb)
  };

  const handleEditQuestion = (values) => {
    console.log("edit values", values)
    let data = {
      _id: editData?._id,
      ques: values?.Name,
      ans: values?.Message

    }
    console.log(data, "+++++++++++++++++")
    let url = '/admin/edit_faq'
    const successCb = (res) => {
      setLoading(false)
      console.log(res)
      form.resetFields()
      setOpenEditModal(false)
      getData()
      message.success("Data Updated Successfully")
    }
    const failureCb = (res) => {
      setLoading(false)
    }
    postCall(data, url, successCb, failureCb)
    // form.resetFields();
    // setOpenEditModal(false)
  }
  // const handleEditButton = (record) => {
  //   console.log("edit values", record)
  //   let data = {
  //     _id: record?._id,
  //     title: record?.ques,
  //     message: record?.ans
  //   }
  //   setEditData(data)
  //   console.log("edit dated 2 check", data)
  //   setOpenEditModal(true);
  // }

  const onPageChange = (pageNumber) => {
    console.log('Page: ', pageNumber);
    setPagination((prevPagination) => ({
      ...prevPagination,
      current: pageNumber,
    }));
  };

  const handleDelete = (id) => {
    console.log("id", id)
    setDelId(id)
    setOpenDelModal(true)
  }
  const onDeleteOk = () => {
    setLoading(true)
    let data = {
      faqId: delId,
    }
    console.log("data123", data)
    let url = `/admin/delete_faq?_id=${delId}`
    const successCb = (res) => {
      setLoading(false)
      console.log("delete", res)
      getData()
      message.success("Question Deleted Successfully")
      form.resetFields()
      setDelId(null)
      setOpenDelModal(false)
    }
    const failureCb = (res) => {
      setLoading(false)
    }
    callDelete(url, successCb, failureCb)
  }


  return (
    <>
      <div className='d-flex justify-content-between'>
        <h4 className='p-2 fw-bold'>FAQ</h4>
        {loading && <Spin size="large" className='loader' />}
        <span>
          <Button type='primary' className='purpleButton' onClick={() => setOpenAddModal(true)}>Add Now</Button>
        </span>

      </div>
      <Row className=' justify-content-end'>
        <Search
          placeholder="Search by name.."
          onSearch={handleSearch}
          // enterButton
          allowClear
          style={{ maxWidth:"400px", float: "right", marginBottom: "10px" }}
        />
      </Row>
      {!loading && <Row className='Maincard p-3 justify-content-between'>
        {faq.length > 0 ? faq?.map((record, i) => {
          // console.log("record", record)
          return (
            <Col xs={24} sm={24} md={12} lg={12} className='p-4 mb-2 Maincard'>
              <Row className='fw-bold'><Col span={2} >Q{((pagination.current - 1) * 6) + i + 1} </Col><Col> {record?.ques}</Col></Row>
              <Row><Col span={2} className='fw-bold'>Ans. </Col><Col span={22}> {record?.ans}</Col></Row>
              <Row className='my-2'>
                <Col span={2}> </Col>
                <Col span={22}>
                  <Button type="primary" className='px-3 purpleButton' onClick={() => handleEditButton(record)}>Edit</Button>
                  <Button type="primary" danger className='ms-2 px-lg-3' onClick={() => handleDelete(record?._id)}>Delete</Button>
                </Col>
              </Row>
            </Col>
          )
        })
      :
      <div className='text-center w-100'> 
      <div className='fw-bold'>No Questions !!!</div></div>
      }
      </Row>}
      <Row className='justify-content-end mt-2'>
        <Pagination defaultCurrent={pagination.current} current={pagination?.current} total={pagination?.total} onChange={onPageChange} />
      </Row>
      {openAddModal && <ModalQuestion
        form={form}
        open={openAddModal}
        title="Add Question"
        type="Save"
        onCancel={() => { form.resetFields(); setOpenAddModal(false); }}
        onFinish={handleAddQuestion}
      />
      }
      {openEditModal && <ModalQuestion
        form={form}
        open={openEditModal}
        title="Edit Question"
        data={editData}
        type="Update"
        onCancel={() => { form.resetFields(); setEditData(''); setOpenEditModal(false); }}
        onFinish={handleEditQuestion}
      />
      }
      <Modal
        centered
        open={openDelModal}
        onCancel={() => setOpenDelModal(false)}
        footer={null}
        width={350}
      >
        <div className='text-center'>
          <img src={logoDel} alt="delete_icon" style={{ width: "25%" }} />
        </div>
        <h5 className='text-center'>Delete Question</h5>
        <p>Are you sure you want ot Delete this Question?</p>
        <div>
          <Button type="primary" className='me-2 w-48' style={{ backgroundColor: "#6240C9" }} onClick={onDeleteOk} >Delete</Button>
          <Button danger type="primary" className='w-48 ' onClick={() => { setOpenDelModal(false); setDelId('') }}>Cancel</Button>
        </div>
      </Modal>
    </>
  )
}

export default Faq